import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { Route } from '../../config/router'

export const useGatePayMonthlyPage = (): void => {
  const router = useRouter()
  useEffect(() => {
    // User has navigated to Pay Monthly page when the navigation item is hidden
    router.push(Route.HOME)
  }, [router])
}
